module.exports = __webpack_public_path__ + "img/uiux_dev.86308718.png";